import gql from 'graphql-tag';
import { parseToMutationRequest } from '../../utils/utils';
import { getUserName } from '../../localStorage';

/**
 * GraphQL mutation client for `applyExternalPayment` — the dedicated mutation
 * for vendor-redirect payment flows (PlaceToPay, Stripe Checkout, Adyen HPP).
 *
 * Differs from applyPayment by:
 *  - No paymentCreditCards (vendor handled the card, never reaches us)
 *  - Required vendorName + vendorTransactionId (caller-supplied)
 *  - Optional vendorAuthorizationCode + vendorReceipt + vendorLast4 (audit)
 *
 * Engine treats this as a bookkeeping-only call: idempotency-checked by
 * vendorTransactionId, then runs the same allocation/balance/ar_ops pipeline
 * as the regular applyPayment.
 */
export default (data) => {
  const newData = { ...data };
  newData.userId = getUserName() || newData.userId || '';

  // Whitelist tells parseToMutationRequest "emit raw, don't string-quote".
  // - amount: numeric (Float! in schema)
  // - source: ARSource enum (AGENT_CARE, SELF_CARE, ...) — must be unquoted enum literal
  // - currency: NOT here on purpose — GraphQL 'Currency' is a custom scalar backed by
  //   java.util.Currency, parsed from a StringValue. Emit it quoted ("CRC", "USD")
  //   so the CurrencyCoercing receives a StringValue, not an EnumValue.
  const dataCreate = parseToMutationRequest(newData, [
    'amount',
    'source',
  ]);
  const applyExternalPayment = `applyExternalPayment(input: ${dataCreate})`;
  return gql`
  mutation {
    ${applyExternalPayment} {
      id
    }
  }
`;
};
